import request from './request'

// 查询首页信息
export function banners() {
  return request({
    url: '/banners/queryAll',
    method: 'get'
  })
}

// 查询公司信息

export function companyInfo() {
  return request({
    url: '/companyInfo/show',
    method: 'get'
  })
}

// 公司案例


export function permissions() {
  return request({
    url: '/permissions/project',
    method: 'get'
  })
}

// 新闻中心

export function information(params) {
  return request({
    url: '/information/info',
    method: 'get',
    params
  })
}


// 新闻详情
export function detail(id) {
  return request({
    url:  `/information/info/${id}`,
    method: 'get'
  })
}



// 查询案例
export function detail1(id) {
  return request({
    url: `/permissions/project/${id}`,
    method: 'get'
  })
}

// 提交内容




export function submit(data) {
  return request({
    url:  `businessContact/submit`,
    method: 'post',
    data
  })
}


// 获取今日节日图标

export function getTodayHoliday() {
  return request({
    url: `/holidayPicture/getTodayHoliday`,
    method: 'get'
  })
}












// WEBPACK FOOTER //
// ./src/api/api.js